import { Paper, Typography, useMediaQuery } from '@mui/material';
import { styled, TypographyProps } from '@mui/system';
import { openNewTabAndFocus } from 'utils';
import dlocalGoIcon from '../../assets/icons/dlocal-go.svg';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import styles from './styles.module.scss';
import { Link } from 'components/common/link';
import { useTranslation } from 'react-i18next';
import { Urls } from 'config/urls';

const TypographyInfo = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '10px',
  lineHeight: '14px',
  color: '#595959',
}));

interface FooterProps {
  success?: boolean;
}

const Footer = ({ success }: FooterProps) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width:1024px)');
  return (
    <Paper
      sx={{
        bgcolor: success ? 'transparent' : '#afasfd',
        display: 'flex',
        padding: '22px',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none',
        marginBottom: isDesktop || success ? '0px' : '50px',
        ...((isDesktop || success) && {
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
        }),
      }}
      square
    >
      {success ? (
        <>
          <TypographyInfo className={styles.footer_text_success}>
            {t('footer.success')}
            <Link onClick={() => openNewTabAndFocus(Urls.externals.customerSupport)}>{t('footer.success.contactUs')}</Link>
          </TypographyInfo>
        </>
      ) : (
        <>
          <TypographyInfo className={styles.footer_text}>
            <LockOutlinedIcon fontSize="small" className={styles.footer_lock} />
            {t('footer.securityMessage')}
          </TypographyInfo>
          <div className={styles.footer_logo} onClick={() => openNewTabAndFocus(Urls.externals.dlocal)}>
            <span>Powered by</span>
            <img src={dlocalGoIcon} alt="logo" className="logos-below__img-1" />
          </div>
        </>
      )}
    </Paper>
  );
};

export default Footer;
